module.exports = __webpack_public_path__ + "img/radi8-logo-orange.0f69a384.png";